import React, { Component } from 'react';
import PropTypes from 'prop-types';

class SwipableArea extends Component {
  constructor(props) {
    super(props);
    this.lastX = 0;
    this.lastY = 0;
  }

  componentDidMount = () => {
    const { id } = this.props;
    this.element = document.getElementById(id);
    if (id && this.element) {
      this.element.addEventListener('touchstart', evt => this.setUpTouchStart(evt), false);
      this.element.addEventListener('touchmove', evt => this.handleTouchMove(evt), false);
      this.element.addEventListener('touchend', this.reset(0, 0), false);
    }
  }


  setUpTouchStart = (evt) => {
    this.lastX = evt.touches[0].clientX;
    this.lastY = evt.touches[0].clientY;
  }

  componentWillUnmount = () => {
    const { id } = this.props;
    this.element = document.getElementById(id);
    if (id && this.element) {
      this.element.removeEventListener('touchstart', this.setUpTouchStart);
      this.element.addEventListener('touchmove', this.handleTouchMove);
      this.element.addEventListener('touchend', this.reset);
    }
  }

  reset = (x, y) => {
    this.lastX = x;
    this.lastY = y;
  }

  handleTouchMove = (evt) => {
    const { 
      minimunSpace,
      onSwipeRight,
      onSwipeLeft,
      onSwipeUp,
      onSwipeDown,
    } = this.props;

    const x = evt.touches[0].clientX;
    const y = evt.touches[0].clientY;

    const xDiff = Math.abs(this.lastX - x);
    const yDiff = Math.abs(this.lastY - y);

    const xWay = this.lastX - x > 0 ? 'right' : 'left'; 
    const yWay = this.lastX - y > 0 ? 'down' : 'up';

    if(onSwipeRight && xWay === 'right' && xDiff > minimunSpace) {
      onSwipeRight();
      this.reset(x, y);
    }
    if(onSwipeLeft && xWay === 'left' && xDiff > minimunSpace) {
      onSwipeLeft();
      this.reset(x, y);
    }
    if(onSwipeDown && yWay === 'down' && yDiff > minimunSpace) {
      onSwipeDown();
      this.reset(x, y);
    }
    if(onSwipeUp && yWay === 'up' && yDiff > minimunSpace) {
      onSwipeUp();
      this.reset(x, y);
    }
  }

  render() {
    const { children, id } = this.props;
    if (!id) {
      errorLog('[SwipableArea]: must have id')
    }
    return (
      <div id={id}>
        { children }
      </div>
    )
  }
}

SwipableArea.propTypes = {
  /**
   * {
   *  "info": "Define el identificador del componente",
   *  "kind": "both",
   *  "beautifulName": "Identificador"
   * }
   */
  id: PropTypes.string.isRequired,
  /**
   * {
   *  "info": "Recorrido mínimo con el dedo para que se produzca un swipe",
   *  "kind": "playground",
   *  "beautifulName": "Mínimo Swipe"
   * }
   */
  minimunSpace: PropTypes.number,
  /**
   * {
   *  "info": "Función js que se ejecutará al hacer swipeRight, si es necesario",
   *  "kind": "playground",
   *  "beautifulName": "Función Right"
   * }
   */
  onSwipeRight: PropTypes.func,
   /**
   * {
   *  "info": "Función js que se ejecutará al hacer swipeLeft, si es necesario",
   *  "kind": "playground",
   *  "beautifulName": "Función Left"
   * }
   */
  onSwipeLeft: PropTypes.func,
   /**
   * {
   *  "info": "Función js que se ejecutará al hacer swipeUp, si es necesario",
   *  "kind": "playground",
   *  "beautifulName": "Función Up"
   * }
   */
  onSwipeUp: PropTypes.func,
   /**
   * {
   *  "info": "Función js que se ejecutará al hacer swipeDown, si es necesario",
   *  "kind": "playground",
   *  "beautifulName": "Función Down"
   * }
   */
  onSwipeDown: PropTypes.func,
}

SwipableArea.defaultProps = {
  minimunSpace:  800,
  onSwipeRight: null,
  onSwipeLeft: null,
  onSwipeUp: null,
  onSwipeDown: null,
}


export default SwipableArea;
